import CalendarUtils from 'services/CalendarUtils';
import moment from 'moment-timezone';
import PerformanceUtils from 'services/PerformanceUtils';

const google = window.google;

class ClinicUtils {
  getInitials(clinic) {
    const name = clinic?.name;
    if (!name) {
      return '';
    }
    const [, ...names] = name.split(' ');
    return names.map((it) => it[0]).join('');
  }

  getBusyRooms(queue) {
    return queue.filter((item) => !!item.room).map((item) => item.room);
  }

  getAddress(clinic = {}) {
    let address = clinic.address || {};
    let fields = [
      address.line1,
      address.line2,
      address.postcode,
      address.city,
      address.state,
      address.country,
    ].filter((field) => !!field);
    return fields.join(', ');
  }

  getAddressAsObject(clinic = {}) {
    return clinic.address || {};
  }

  getLatLng(clinic = {}) {
    let { latitude, longitude } = clinic.address || {};
    return { latitude, longitude };
  }

  getGoogleLatLng(clinic = {}) {
    let address = clinic.address;
    if (!!address?.latitude && !!address?.longitude && google) {
      return new google.maps.LatLng({
        lat: parseFloat(address.latitude),
        lng: parseFloat(address.longitude),
      });
    }
  }

  getPhone(clinic = {}) {
    return clinic.phone;
  }

  getFax(clinic = {}) {
    return clinic.fax;
  }

  getLifeLabsContractNumber() {
    return officeContact.lifelabs_contract;
  }

  getEmail(clinic = {}) {
    return clinic.email;
  }

  isOpenNow(hours, type = 'video') {
    return !this.isClosedNow(hours, type);
  }

  isClosedNow(hours, type = 'video') {
    const FORMAT = 'h:mm A';

    if (!this.isOpenToday(hours, type)) return true;

    let opening = this.getOpeningHours(hours, type);
    let closing = this.getClosingHours(hours, type);
    let now = CalendarUtils.format(moment().unix(), FORMAT);

    return (
      moment(now, FORMAT).isAfter(moment(closing, FORMAT)) ||
      moment(now, FORMAT).isBefore(moment(opening, FORMAT))
    );
  }

  isOpenToday(hours, type = 'video', day = this.getToday()) {
    hours = this.getHours(hours, type, day);
    return hours.shut !== true;
  }

  getOpeningHours(hours, type = 'video', day = this.getToday()) {
    hours = this.getHours(hours, type, day);
    if (hours.shut) return 'Closed';
    return CalendarUtils.formatMilitaryTime(hours.open);
  }

  getClosingHours(hours, type = 'video', day = this.getToday()) {
    hours = this.getHours(hours, type, day);
    if (hours.shut) return 'Closed';
    return CalendarUtils.formatMilitaryTime(hours.close);
  }

  getToday() {
    let day = moment().day() - 1;
    if (day < 0) day = 7 - 1;
    return day;
  }

  getHours(hours, type = 'video', day = 0) {
    if (hours) return hours[type][day];
    return {};
  }

  filterQueuePatients(queue = [], role, ownId, physicians = {}) {
    if (role === 'physician') {
      queue = queue.filter((element) => {
        return (
          element.physician_id === undefined ||
          element.physician_id === ownId ||
          physicians[ownId]?.intern_of === element.physician_id ||
          (element.physician_id === physicians[element.physician_id]?.id &&
            physicians[element.physician_id]?.intern_of === ownId)
        );
      });
    }
    return PerformanceUtils.sortBy(queue, ['date'], false);
  }

  prepareHours(hours = {}) {
    let result = PerformanceUtils.clone(hours);
    for (let type in result) {
      for (let index in result[type]) {
        if (!result[type][index].open || !result[type][index].close)
          result[type][index] = { shut: true };
        else {
          result[type][index].open = parseInt(result[type][index].open);
          result[type][index].close = parseInt(result[type][index].close);
          delete result[type][index].shut;
        }
      }
    }
    return result;
  }
}

//TODO multiclinic
const officeContact = {
  lifelabs_contract: 'LifeLabs Contract #: W-704',
};

export default new ClinicUtils();
